import _ from 'lodash';
import React, { useMemo, useState, useCallback } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { useConfig, useGlobalContext } from '~/context';
import { log } from '@swiper/core';
import { PersonList } from '~/components';
import * as overlays from '~/overlays';
import { Icon, ErrorBox, Button } from '~/utils';
import { useDebug } from '~/hooks';

export default function SessionPage( props ) {
  const config = useConfig();
  const {
    session, error, swipe, dispatch, member,
  } = useGlobalContext();
  const [ overlay, setOverlay ] = useState( null );

  log.debug( 'MEMBER', member );
  const closeOverlay = useCallback( () => {
    setOverlay( false );
  }, [ setOverlay ] );

  useDebug( 'session', session );

  const can_bring = useMemo( () => {
    if ( ! member ) return {};
    return _.fromPairs( _.map( [
      'family', 'friend', 'guest',
    ], x => ( [ x, member.flag( `bring_${x}`, `bring_${x}s` ) ] ) ) );
  }, [ member ] );

  const handlePick = useCallback( ( pick ) => {
    log.debug( 'handlePick', pick );
    if ( _.isFunction( overlays[ pick.id ] ) ) {
      setOverlay( pick.id );
    } else {
      if ( pick.id === swipe.member.id ) return swipe.toggle( pick );
      if ( can_bring[ pick.relation ] ) {
        swipe.toggle( pick );
      } else {
        // TODO - toast
      }
    }
  }, [ swipe, can_bring ] );

  const { friends, guests } = useMemo( () => {
    const guest_limit = config.guest_limit || 3;
    const active = _.filter( _.flatten( _.at( session, [
      'friends', 'guests',
    ] ) ), 'present' );
    const total = active.length;
    const canadd = total < guest_limit;
    const gu = [].concat( session.guests );
    const fr = [].concat( session.friends );
    log.debug( 'CANBRING', can_bring );
    if ( can_bring.guest ) {
      if ( canadd ) {
        gu.push( {
          id          : 'AddGuestOverlay',
          displayName : <i>Add a Guest</i>,
        } );
      } else {
        gu.push( {
          // id          : 'GuestLimitOverlay', // TODO
          displayName : <i>Guest Limit Reached</i>,
        } );
      }
    }
    if ( can_bring.friend ) {
      if ( canadd ) {
        fr.push( {
          id          : 'AddFriendOverlay',
          displayName : <i>Add a Friend</i>,
        } );
      } else {
        fr.push( {
          // id          : 'GuestLimitOverlay', // TODO
          displayName : <i>Guest Limit Reached</i>,
        } );
      }
    }
    return { friends : fr, guests : gu };
  }, [ config, session, can_bring ] );
  log.debug( 'F/G', { friends, guests, can_bring } );

  const message = useMemo( () => {
    // TODO - If staff offer additional staff options buttons
    if ( member.is_staff ) {
    } else if ( _.some( can_bring ) ) {
      return (
        <div className="my-5">
          <p>
            To sign someone in or out, press
            the <kbd>letter</kbd> or <kbd>number</kbd> next
            to their name.
          </p>
          <Icon icon="far:user-circle" /> = Signed in
            &nbsp; &nbsp; &nbsp; &nbsp;
          <Icon icon="far:circle" /> = Signed out
        </div>
      );
    } else {
    }
  }, [ member, can_bring ] );

  if ( error ) return <ErrorBox error={error} />;

  if ( overlay ) {
    log.debug( 'OVERLAY ENABLED', overlay );
    const Overlay = overlay && overlays[ overlay ];
    if ( Overlay ) {
      return <Overlay close={closeOverlay} />;
    } else {
      return <ErrorBox error={`Invalid overlay "${overlay}"`} />;
    }
  }

  return (
    <Container className="actions h-100" fluid>
      <Row >
        <Col>
          <PersonList
            title="Family"
            people={session.members}
            onPick={handlePick}
            selectors="letters"
            data-testid="family-list"
          />
        </Col>
        <Col>
          <PersonList
            title="Guests"
            people={guests}
            onPick={handlePick}
            selectors="numbers"
            data-testid="guests-list"
          />
          <PersonList
            title="Friends"
            people={friends}
            onPick={handlePick}
            selectors="numbers"
            startAt={guests.length}
            data-testid="friends-list"
          />
          {message}
          <Button block onClick={dispatch.reset} shortcut="Escape">
            Finished
          </Button>
        </Col>
      </Row>
    </Container>
  );
}
SessionPage.propTypes = {
};
